import React, { useEffect, useRef } from 'react'

/**
 * A ref object whose `.current` property is set to `true` when the component
 * is mounted and `false` when it is unmounted.
 * @typedef {Object} MountedRef
 * @property {boolean} current
 * @memberof useMountedRef
 */
export type MountedRef = React.RefObject<boolean>

/**
 * Returns a ref object whose `.current` property is set to `true` when the
 * component is mounted and `false` when it is unmounted.
 * @function useMountedRef
 * @returns {MountedRef}
 */
export default function useMountedRef(): MountedRef {
  const mounted = useRef<boolean>(false)

  useEffect(() => {
    mounted.current = true
    return () => {
      mounted.current = false
    }
  }, [])

  return mounted
}
